export default {
  title: '{{plan}} está ativo',
  plan: 'Plano: {{plan}}',
  free_until: 'Gratuito até {{date}}',
  continue: 'Continuar',
};
